var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSLetterBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H11.5601C11.4485 0 11.4187 0.16197 11.5213 0.205491C14.7717 1.58399 16.2156 4.07665 16.7438 5.26909C16.7905 5.37445 17 5.33682 17 5.22178V0.989979C17 0.443229 16.5523 0 16 0Z",
    fill: "#564ECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43989 15H1C0.447716 15 8.6722e-08 14.5568 8.6722e-08 14.01V9.77822C8.6722e-08 9.66318 0.209542 9.62555 0.25621 9.73091C0.784367 10.9234 2.22833 13.416 5.47866 14.7945C5.58128 14.838 5.55153 15 5.43989 15Z",
    fill: "#564ECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.922137 0.182956C1.0991 0.910996 2.1998 2.61719 5.18691 3.61766C8.1174 4.85767 11.3629 6.30671 12.6193 6.87622C14.6839 7.7804 18.2148 10.635 15.8223 14.8201C15.8173 14.8201 15.8058 14.7961 15.7844 14.7521C15.6537 14.4821 15.1571 13.4564 13.5749 12.5479C12.0176 11.7447 5.91836 9.06621 3.06337 7.82737C1.35274 7.00539 -1.47039 4.32574 0.922137 0.182956Z",
    fill: "#564ECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLetterBlue);
export default __webpack_public_path__ + "static/media/SLetterBlue.924470df4bacf95aeca9b93645787ee1.svg";
export { ForwardRef as ReactComponent };